<div class='course'>
  <div [ngClass]="['header', courseCssService.responsiveClass()]" *ngIf='!isEditing'>
    <div class='display blue' (click)='toggleCourseExpanded(course)'>
      <p class='collection-column'>{{resources.findCollection(course.collectionUuid) ?
              resources.findCollection(course.collectionUuid).name : ''}}</p>
      <div class='separator'></div>
      <p class='semester-column'>{{course.startDate.month}} {{course.startDate.day}}, {{course.startDate.year}}</p>
      <div class='separator'></div>
      <p class='type-column'>{{ course.classType }}</p>
      <p class='toggle-column'><button (click)='toggleCourseExpanded(course)'class='dropdown-button'><i class="{{isCourseExpanded() ? 'mt-arrow-up' : 'mt-arrow-down'}}"></i></button></p>
    </div>
    <div class='display white'>
      <p class='count-column' (click)='toggleCourseExpanded(course)'>{{ course.displayableLessons.length }} Lessons</p>
      <button class='bowling-button' (click)='gotoBowlingPage()'><i class='mt-bowling'></i></button>
      <div class='separator no-background'></div>
      <button class='ellipsis-button' (click)='showCourseMenu($event)'><i class='mt-more'></i></button>
      <div class='separator no-background toggle-column'></div>
      <button class='toggle-column' (click)='toggleCourseExpanded(course)' class='dropdown-button'><i class="{{isCourseExpanded() ? 'mt-arrow-up' : 'mt-arrow-down'}}"></i></button>
    </div>
  </div>

  <div class='header edit' *ngIf='isEditing'>
    <app-course-header-edit [course]='course' (save)='saveEditCourse()' (cancel)='cancelEditCourse()' [resources]='resources' [teacher]='teacher'></app-course-header-edit>
  </div>
  <app-course-lesson-list [hidden]='!isCourseExpanded()' [course]='course' [teacher]='teacher' [resources]='resources' [isEditing]='isEditing'></app-course-lesson-list>
</div>